import React, { useState, useEffect } from 'react';
import { 
  LoginContainer,
  FloatingLogo
} from '../Components/UI/Containers'; 
import { 
  LoginCard,
  CardLogo
} from '../Components/UI/Cards';
import { 
  WelcomeTitle 
} from '../Components/UI/Typography';
import { useAuth } from '../Context/AuthContext'; 
import AuthTabs from '../Components/Auth/AuthTabs';

const LoginPage = () => { 
  const [localError, setLocalError] = useState(null); 
  const [activeTab, setActiveTab] = useState('login');

  // Auth context
  const { login, isLoading, authError } = useAuth(); 

  // Effects
  useEffect(() => {
    setLocalError(authError);
  }, [authError]);

  const handleLogin = async (credentials) => {
    setLocalError(null);
    const success = await login(credentials); 

    if (!success) {
      console.log("Login attempt failed");
    } else {
      console.log("Login attempt successful");
    }
  };

  return (
    <LoginContainer> 
      <FloatingLogo 
        src="/assets/white-background-removebg-preview.png" 
        alt="Corporate101 Logo" 
      /> 
      
      <LoginCard> 
        <CardLogo 
          src="header.png" 
          alt="Corporate101 Logo" 
        />
        <WelcomeTitle>
          {activeTab === 'login' ? 'Welcome Back' : 'Register Your Company'}
        </WelcomeTitle>

        <AuthTabs 
          onLogin={handleLogin}
          isLoading={isLoading}
          error={localError}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </LoginCard> 
    </LoginContainer> 
  );
};

export default LoginPage;
